import React from "react";
import "../csscontainer/Footer.css";
import "../App.css";
import { motion } from "framer-motion";
import Footer from "../components/Footer";
import Text from "../components/Text";
import { TEXT } from "../utility/constants";
import global from "../assets/images/globalLog.png";
import TextBox from "../components/TextBox"; // ASSUMPTION: Update the path to your provided image

function GlobalLogistics() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="home-wrapper">
        {/* --- NEW SECTION FOR IMAGE ON RIGHT AND TEXT ON LEFT --- */}
        <div className="service-intro-section">
          <div className="service-intro-image">
            <img
              src={global} // Your IT service image
              alt="Diverse IT Service Projects and Solutions"
              className="responsive-service-image"
            />
          </div>
          <div className="service-intro-text">
            <Text
              color="black"
              size="32px"
              weight="bold"
              align="start"
              style={{ marginBottom: "15px" }}
            >
              {TEXT.globalHeading}
            </Text>
            <Text
              color="black"
              size="22px"
              weight="bold"
              align="start"
              style={{ marginBottom: "15px" }}
            >
              {TEXT.globalDesc}
            </Text>
          </div>
        </div>
        ;
        <div style={{ marginTop: "40px", marginBottom: "40px" }}>
          <TextBox
            title={TEXT.globalH1}
            bulletPoints={[TEXT.globalHD1]}
            showBorder={false}
          />
          <TextBox
            title={TEXT.globalH2}
            bulletPoints={[TEXT.globalHD2]}
            showBorder={false}
          />
          <TextBox
            title={TEXT.globalH3}
            bulletPoints={[TEXT.globalHD3]}
            showBorder={false}
          />
          <TextBox
            title={TEXT.globalH4}
            bulletPoints={[TEXT.globalHD4]}
            showBorder={false}
          />
          <TextBox
            title={TEXT.globalH5}
            bulletPoints={[TEXT.globalHD5]}
            showBorder={false}
          />
        </div>
        <Footer />
      </div>
    </motion.div>
  );
}
export default GlobalLogistics;
